/**
 * batch-311 — the AI evidence strip. At the moment of action (above the draft the
 * operator is about to review/send), it states honestly that the message is
 * AI-drafted and surfaces what it drew on: the count of operator-CONFIRMED facts
 * about the contact + the model's confidence (both persisted per draft). Renders
 * NOTHING when there's no signal, so it never adds empty noise.
 */
export function AiEvidenceStrip({
  confidence,
  factsUsed,
}: {
  confidence?: number | null;
  factsUsed?: number | null;
}) {
  const hasConfidence = typeof confidence === 'number' && Number.isFinite(confidence);
  const hasFacts = typeof factsUsed === 'number' && factsUsed > 0;
  // No real signal → render nothing (avoid a bare, generic "AI-drafted" line).
  if (!hasConfidence && !hasFacts) return null;
  return (
    <p className="ai-evidence-strip" data-testid="ai-evidence-strip">
      <span aria-hidden>✨</span> AI-drafted
      {hasFacts ? (
        <span className="ai-evidence-item">
          {' · '}from {factsUsed} confirmed fact{factsUsed === 1 ? '' : 's'}
        </span>
      ) : null}
      {hasConfidence ? (
        <span className="ai-evidence-item">
          {' · '}
          {Math.round((confidence as number) * 100)}% confident
        </span>
      ) : null}
    </p>
  );
}
